module.exports = __webpack_public_path__ + "img/332.261d35c2.png";